module.exports = __webpack_public_path__ + "twitter-de126f705e89a82e379efb73593e372d.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/icons/twitter.svg
// module id = 454
// module chunks = 0